import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: {
    text: 'Step 1'
  },
  subtitle: {
    text: 'Share your details'
  },
  statusCardImage: {
    imageUrl: 'https://assets.airtel.in/static-assets/airtel-widgets/e-sim/images/social-proof.png'
  },
  type: 'image',
  svg: {
    iconName: 'TickIcon',
    svgBackgroundProps: {
      type: 'SUCCESS'
    }
  },
  hintText: '',
  animatedNumber: 0,
  showCollapsible: false,
  collapsibleData: [],
  collapsibleCtaData: {},
  ctaTitle: '',
  ctaOnPress: {},
  loader: {},
  withCard: false,
  timerProps: {},
  id: '',
  buttonType: 'tertiary'
}, getTestId('StatusCardWidgetContainer'));